"use client";

import React from "react";
import { DropdownInput } from "@/app/(components)/Basic/DropdownInput";
import SortHamburgerIcon from "@/assets/icons/sort-hamburger.svg";
import { ShortNft } from "@/api/nfts/types";
import { Masonry } from "@/app/(components)/Wrappers/Masonry";
import { MasonryColumns } from "@/shared/constants";
import { ArtworkList } from "../../Artwork/ArtworkList";
import { ArtworkMasonryItem } from "../../Artwork/ArtworkMasonryItem";
import { NFT_LIST_OPTIONS, NftSortValues } from "../../Collections/types";
import { User } from "@/api/users/types";

export interface Props {
  nfts: ShortNft[];
  sortOption?: NftSortValues;
  setSortOption?: (option: NftSortValues) => void;
  artistIsVisible?: boolean;
  hasDropdownFilter?: boolean;
  artist?: User;
  hasNextPage: boolean;
  fetchNextPage: () => void;
}

const NftList = ({
  nfts,
  sortOption,
  setSortOption,
  artistIsVisible = false,
  hasNextPage,
  fetchNextPage,
}: Props) => {
  return (
    <>
      {!!sortOption && !!setSortOption && (
        <div className="lg:absolute lg:top-[-10px] lg:max-w-[280px] w-[327px]">
          <DropdownInput
            text={"Sort by:"}
            options={NFT_LIST_OPTIONS}
            startIcon={<SortHamburgerIcon />}
            className="h-[40px] text-body-3 p-4 lg:mb-0 mb-5 w-full"
            setSelectedOption={setSortOption}
            selectedOption={sortOption}
          />
        </div>
      )}
      <Masonry
        singleColumnList={
          <ArtworkList nfts={nfts} artistVisible={artistIsVisible} />
        }
        loading={false}
        columnsDisplay={MasonryColumns.Triple}
        hasMore={hasNextPage}
        handleLoadMore={fetchNextPage}
      >
        {nfts.map((nft, index: number) => {
          return (
            <ArtworkMasonryItem
              name={nft.name}
              artist={nft?.artist}
              artistVisible={artistIsVisible}
              imageSrc={nft.thumbnail || nft.image}
              mediaType={nft.mediaType}
              imageHeight={nft.imageHeight}
              imageWidth={nft.imageWidth}
              orientation={nft.imageOrientation}
              placeholder={nft.placeholder}
              swap={false}
              key={index}
              id={nft.id}
            />
          );
        })}
      </Masonry>
    </>
  );
};

export default NftList;
